<template>
    <div class="tw-fieldset-box">
        <div class="row">
            <div class="col-2">
                <div class="tw-fieldset-box-label">
                    {{ label }}
                </div>
            </div>
            <div class="col">
                <div class="tw-fieldset-box-body">
                    <div v-for="locale in locales" class="content-fields-box-container">
                        <content-fields  :configuration="configuration" :locale="locale" :content-key="contentKey"
                                        :contents="contentsForLocale(locale)" :partner-id="partnerId"
                                        :partner-group-id="partnerGroupId"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ContentFields from './ContentFields';
  import _ from 'lodash';

  export default {
    name: "ContentFieldset",

    computed: {
      contentsPerLocale() {
        return _.groupBy(this.contents, 'locale');
      }
    },

    methods: {
      contentsForLocale(locale) {
        const contents = this.contentsPerLocale[locale];

        if (_.isArray(contents)) {
          return contents;
        }

        return [];
      }
    },

    props: {
      label: {
        type: String,
        required: true
      },
      contentKey: {
        type: String,
        required: true
      },
      locales: {
        type: Array,
        required: true
      },
      partnerId: {
        type: String,
        required: false,
        default: null
      },
      partnerGroupId: {
        type: String,
        required: false,
        default: null
      },
      contents: {
        type: Array
      },
      configuration: {
        type: Object,
        required: true
      }
    },

    components: {
      ContentFields
    }
  };
</script>

<style scoped>
    .content-fields-box-container{
        padding-top: .5rem;
    }
    .content-fields-box-container:first-child{
        padding-top:0;
    }
</style>